module.exports = __webpack_public_path__ + "static/img/scrollImg4.519a17c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scrollImg4.png
// module id = i3C1
// module chunks = 2